/* eslint-disable no-plusplus */
import React from 'react';
import {
  Table,
} from 'reactstrap';
import 'firebase/storage';
import styled from 'styled-components';
import {
  faMobileAlt,
  faEdit,
  faEnvelope,
  faPrint,
  faCheckCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GetFormattedDate } from './FormatDate';

const BorderedDiv = styled.td`
  border: 1px solid black;
`;

const BorderedHeader = styled.th`
  border: 1px solid black !important;
`;

const RenderArray = ({ data }) => (
  <div>
    {data.map(item => (
      <div key={item}>
        <a href={item}>
          {item.split('%2F')[1].split('?alt')[0]}
        </a>
      </div>
    ))}
  </div>
);

// eslint-disable-next-line import/prefer-default-export
export const PetTreatmentTable = ({
  petTreatmentList, openTreatment, toggleSendMessage, toggleSendEmail, togglePrintCertificate,
}) => {
  let i = petTreatmentList.length;
  return (
    <Table
      responsive
      size="sm"
      striped
      style={{ backgroundColor: '#e6f2ff' }}
    >
      <thead>
        <tr>
          <BorderedHeader>Fn</BorderedHeader>
          <BorderedHeader>#</BorderedHeader>
          <BorderedHeader>Date</BorderedHeader>
          <BorderedHeader>Weight</BorderedHeader>
          <BorderedHeader>Symptoms</BorderedHeader>
          <BorderedHeader>Diagnosis</BorderedHeader>
          <BorderedHeader>Treatment</BorderedHeader>
          <BorderedHeader>Notes</BorderedHeader>
          <BorderedHeader>Vaccination</BorderedHeader>
          <BorderedHeader>Deworming</BorderedHeader>
          <BorderedHeader>Amount</BorderedHeader>
          <BorderedHeader>Reports</BorderedHeader>
        </tr>
      </thead>
      <tbody>
        {petTreatmentList.length > 0 && petTreatmentList.map(treatment => (
          <tr key={treatment.id}>
            <BorderedDiv>
              <FontAwesomeIcon
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                onClick={() => { openTreatment(treatment.id); }}
                icon={faEdit}
              />
            </BorderedDiv>
            <BorderedDiv>
              {i--}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.date ? (
                <div>
                  {GetFormattedDate(treatment.date.seconds * 1000)}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.weight ? (
                <div>
                  {treatment.weight}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.symptoms ? (
                <div>
                  {treatment.symptoms}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.diagnosis ? (
                <div>
                  {treatment.diagnosis}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.treatment ? (
                <div>
                  {treatment.treatment}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.note ? (
                <div>
                  {treatment.note}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.vaccination && treatment.vaccination.length > 0 ? (
                <div>
                  <div className="d-flex justify-content-between">
                    <FontAwesomeIcon
                      style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                      onClick={() => { toggleSendEmail(treatment.id, treatment.vaccination); }}
                      icon={faEnvelope}
                    />

                    <FontAwesomeIcon
                      style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                      onClick={() => { toggleSendMessage(treatment.id, treatment.vaccination); }}
                      icon={faMobileAlt}
                    />

                    <FontAwesomeIcon
                      style={{ textDecoration: 'none', color: 'black', cursor: 'pointer' }}
                      onClick={() => { togglePrintCertificate(treatment); }}
                      icon={faPrint}
                    />
                  </div>
                  <div className="d-flex justify-content-between">
                    {treatment.sentEmail ? (
                      <FontAwesomeIcon
                        style={{ textDecoration: 'none', color: '#026929' }}
                        icon={faCheckCircle}
                      />
                    ) : (
                      <div />
                    )}
                    {treatment.sentSms ? (
                      <FontAwesomeIcon
                        style={{ textDecoration: 'none', color: '#026929' }}
                        icon={faCheckCircle}
                      />
                    ) : (
                      <div />
                    )}
                    <div />
                  </div>
                  <div className="d-flex justify-content-center" />
                  {treatment.vaccination.map(row => (
                    <div key={row.value}>
                      -
                      {' '}
                      {row.label}
                    </div>
                  ))}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.deworming ? (
                <div>
                  {treatment.deworming}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.amount ? (
                <div>
                  {treatment.amount}
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
            <BorderedDiv>
              {treatment.reports ? (
                <div>
                  <RenderArray
                    id={treatment.id}
                    data={treatment.reports}
                  />
                </div>
              ) : (
                <div />
              )}
            </BorderedDiv>
          </tr>
        ))
        }
      </tbody>
    </Table>
  );
};
